module.exports = {
  appUrl: process.env.APP_URL || 'https://hlm.homelight.com',
  homePageUrl: process.env.HOME_PAGE_URL || 'https://disclosures.io',

  hubspot: {
    signupPortal: parseInt(process.env.HUBSPOT_SIGNUP_PORTAL) || 4744876,
    signupForm: process.env.HUBSPOT_SIGNUP_FORM || '300e31f0-e97a-4367-a831-be35c96098d8',
  },
}
